export default class {
    static projectName = "Apprenticeshipwale";
    static userData = "USER_DATA";
    static themeColor = '#3b5de7'


    static emailRjx = /\S+@\S+\.\S+/;
}